<template>
  <div class="flex items-center">
    <div class="w-8 h-8 bg-orange-100 rounded-full flex items-center justify-center mr-3">
      <svg class="w-5 h-5 text-orange-600" fill="none" stroke="currentColor" viewBox="0 0 24 24">
        <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M16 7a4 4 0 11-8 0 4 4 0 018 0zM12 14a7 7 0 00-7 7h14a7 7 0 00-7-7z" />
      </svg>
    </div>
    <div class="flex-1 min-w-0">
      <p class="text-sm font-medium text-gray-900 truncate">{{ userStore.user?.name }}</p>
      <p class="text-xs text-gray-500">{{ userRoleDisplay }}</p>
    </div>
  </div>
</template>

<script>
import { computed } from 'vue'
import { useUserStore } from '../stores/user'

export default {
  name: 'UserDisplay',
  setup() {
    const userStore = useUserStore()

    const userRoleDisplay = computed(() => {
      const role = userStore.user?.role
      
      // Dynamic role mapping - easy to extend for future roles
      const roleMap = {
        'admin': 'Administrator',
        'staff': 'Staff Member', 
        'workshop': 'Workshop Staff',
        'customer': 'Customer'
      }
      
      // Return mapped role or capitalize the role if not in map
      return roleMap[role] || (role ? role.charAt(0).toUpperCase() + role.slice(1) : 'User')
    })

    return {
      userStore,
      userRoleDisplay
    }
  }
}
</script>
